import { render, staticRenderFns } from "./BlackWhiteListModal.vue?vue&type=template&id=62158c01&"
import script from "./BlackWhiteListModal.vue?vue&type=script&lang=js&"
export * from "./BlackWhiteListModal.vue?vue&type=script&lang=js&"
import style0 from "./BlackWhiteListModal.vue?vue&type=style&index=0&id=62158c01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports